import script from "./videos.vue?vue&type=script&setup=true&lang=js"
export * from "./videos.vue?vue&type=script&setup=true&lang=js"

import "./videos.vue?vue&type=style&index=0&id=69159549&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69159549"]])

export default __exports__